import React from 'react';
import logo from './images/only-logo.png'
import { Redirect, Route, Switch, useParams } from "react-router-dom";
import './Header.css'
import User from "./user/User";
import Nav from "./nav/Nav";
import { connect } from 'react-redux';
import { technology } from '../../config/technology';
import { Divider } from 'antd';
function RedirectPage(props: {
    userName: string
}) {
    let defaultSpec: string = "";
    for (let spec in technology) {
        defaultSpec = spec;
        break;
    }
    let { page } = useParams<{ page: string }>()
    return (<Redirect to={`/${props.userName}/${page}/${defaultSpec}`} />)
}


function Header(props: {
    userName: string
}) {
    return (
        <div className='header container-fluid'>
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {/* logo */}
                <div style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                    <img style={{ objectFit: 'contain', height: 45 }} src={logo} alt='logo' />
                    <span style={{ color: 'white', fontSize: 20, fontWeight: 'bolder', marginLeft: 10 }}>国勘云</span>
                    <Divider type="vertical" style={{ height: '28px', borderColor: '#7786c5', width: 5 }} />
                </div>

                <Switch>
                    {/* 登录界面时不显示除logo外其他组件 */}
                    <Route path={`/signin`}>
                        <div className="col-md-10" />
                    </Route>
                    {/* <Route path={`/register`}>
                        <div className="col-md-10" />
                    </Route> */}
                    <Route path={`/${props.userName}/:page/:spec`}>

                        {/* 主导航 */}
                        <Nav />

                        {/* 用户信息 */}
                        <div>
                            <User />
                        </div>
                    </Route>

                    {/* 默认跳转 */}
                    <Route path={`/${props.userName}/:page`}>
                        <RedirectPage userName={props.userName} />
                    </Route>
                    <Route path={`/`}>
                        <div className="col-md-7" />
                    </Route>
                </Switch>
            </div>
        </div >
    )
}

const mapStateToProps = (state: {
    user: { userName: string }
}) => {
    return {
        userName: state.user.userName,
    };
};

export default connect(
    mapStateToProps
)(Header);